import { render, staticRenderFns } from "./ChartkickComponents.vue?vue&type=template&id=81c935dc&"
import script from "./ChartkickComponents.vue?vue&type=script&lang=js&"
export * from "./ChartkickComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports